import { render, staticRenderFns } from "./MenuPainelFluxo.vue?vue&type=template&id=06fc9df7&"
import script from "./MenuPainelFluxo.vue?vue&type=script&lang=js&"
export * from "./MenuPainelFluxo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports